import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { CompanyIntentPayloadInterface, CompanyIntentResponseInterface } from 'src/app/company-detail/models';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class CompaniesApiService {
    private readonly url: string = 'service/contactcloud/companies';

    constructor(private readonly baseApiService: BaseApiService) {}

    getCompetitors(company_ids: string[]): Observable<any> {
        return this.baseApiService.post<any>(`${this.url}/competitorsV2`, { company_ids });
    }
    
    getIntents(data: CompanyIntentPayloadInterface): Observable<CompanyIntentResponseInterface> {
        return this.baseApiService.post<CompanyIntentResponseInterface>(`${this.url}/search`, data)
    }
    
    getSpecialities(query: string): Observable<any[]> {
        return this.baseApiService.get(`${this.url}/specialties`, {params: {keyword: query}});
    }

    getPopularKeywords(query: string): Observable<any[]> {
        return this.baseApiService.get(`${this.url}/popularKeywords`, {params: {coreKeyword: query}});
    }
}
